<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import WorkView from '../components/stores/WorkView.vue'
import StoresIndex from '../components/stores/StoresIndex.vue'
//Translations
const { t } = useI18n({ useScope: 'global' })
const storeItemsLabel = (key: string) => t(`tables.${key}`)

//Tabs
const tab = ref('workView')

//WorkView
</script>
<template>
  <q-page class="q-pt-sm">
    <q-tabs
      v-model="tab"
      class="text-grey"
      active-color="secondary"
      indicator-color="secondary"
      align="left"
      narrow-indicator
    >
      <q-tab name="workView" :label="storeItemsLabel('workView')" />
      <q-tab name="stores" :label="storeItemsLabel('stores')" />
    </q-tabs>
    <q-separator />
    <q-tab-panels v-model="tab" keep-alive animated>
      <q-tab-panel keep-alive name="workView">
        <WorkView key="workView" />
      </q-tab-panel>
      <q-tab-panel keep-alive name="stores">
        <StoresIndex key="storeIndex" />
      </q-tab-panel>
    </q-tab-panels>
  </q-page>
</template>

<style>
.cursor-pointer {
  cursor: pointer;
}

.q-menu {
  z-index: 7001;
}

.full-width {
  width: 100%;
}

.collapsed .q-table__middle {
  height: 0px;
}
</style>
